<template>
  <div class="history-popup">
    <a-layout-sider theme="light" :width="302">
      <div class="history-menu">
        <a-icon
          v-if="showCloseIcon"
          class="history-menu__close sidebar-close"
          type="close"
          @click="$emit('toggleHistory')"
        />

        <a-menu
          v-if="history"
          class="nav"
          mode="inline"
          :defaultOpenKeys="defaultOpenKeys"
          :selectedKeys="selectedKeys"
          @select="selectVersion"
        >
          <a-menu-item-group>
            <template slot="title">
              <span class="nav__top-section">История версий</span>
            </template>

            <a-sub-menu v-for="day of historyByDays" :key="day.timestamp">
              <span slot="title">
                <span>{{ formatDay(day.timestamp) }}</span>
              </span>
              <a-menu-item v-for="version in day.entries" :key="version.id">
                <div class="history-entry">
                  {{ formatTime(version.date) }}
                  <div class="history-entry__author">{{ version.user.name }}</div>
                </div>
              </a-menu-item>
            </a-sub-menu>
          </a-menu-item-group>
        </a-menu>
      </div>
    </a-layout-sider>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { formatDay, formatTime } from '@/helpers';

export default {
  name: 'EntityModalHistory',
  props: {
    value: {
      type: Number,
      default: null,
    },
    showCloseIcon: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '250',
    },
    history: {
      type: Array,
      required: true,
    },
  },

  computed: {
    activeVersion: {
      get() {
        return this.value;
      },
      set(id) {
        this.$emit('input', id);
      },
    },
    selectedKeys() {
      return this.activeVersion ? [this.activeVersion] : [];
    },
    historyByDays() {
      const days = new Map();
      this.history.forEach((entry) => {
        const day = moment(entry.date).startOf('day').format('X');
        const dayEntries = days.get(day) || [];
        if (!dayEntries.length) {
          days.set(day, dayEntries);
        }

        dayEntries.push(entry);
      });

      return Array.from(days).map(([timestamp, entries]) => ({ timestamp, entries }));
    },
    defaultOpenKeys() {
      return [this.historyByDays[0].timestamp];
    },
  },

  created() {
    this.selectVersion({ key: this.historyByDays[0].entries[0].id });
  },

  methods: {
    formatDay,
    formatTime,

    selectVersion({ key }) {
      this.activeVersion = key;
    },
  },
};
</script>

<style lang="scss">
.history-menu {
  &__close {
    float: right;
    position: relative;
    top: 15px;
    right: 20px;
  }
}

.history-entry {
  display: inline-block;
  line-height: 20px;
  vertical-align: middle;

  &__author {
    position: relative;
    top: -2px;
    font-size: 11px;
    line-height: 15px;
    color: #777;
  }
}

.history-popup {
  @include scrollbars();
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  padding-left: 30px;
  padding-bottom: 30px;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #fff;
}

@media (min-width: $tabletBreakpoint) {
  .history-menu__close {
    top: 15px;
    right: 16px;
  }

  .history-menu {
    .ant-menu-item-group-title {
      padding-bottom: 15px;
    }
  }
}

@media (min-width: $desktopBreakpoint) {
  .history-popup {
    padding-left: 0;
  }
}
</style>
